export function Divider() {
  return (
    <div className='h-2 w-2 shrink-0 rounded-full border-2 border-solid border-outline' />
  );
}
